import { render, staticRenderFns } from "./BaseEditor.vue?vue&type=template&id=1a634ad8&scoped=true"
import script from "./BaseEditor.vue?vue&type=script&lang=ts"
export * from "./BaseEditor.vue?vue&type=script&lang=ts"
import style0 from "./BaseEditor.vue?vue&type=style&index=0&id=1a634ad8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a634ad8",
  null
  
)

export default component.exports